var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPopoutIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 677.8 657.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M610.96,657.52H26.76c-14.79,0-26.76-11.97-26.76-26.76V46.56c0-14.79,11.97-26.76,26.76-26.76h289.88c14.79,0,26.76,11.97,26.76,26.76s-11.97,26.76-26.76,26.76H53.51v530.69h530.69v-263.18c0-14.79,11.97-26.76,26.76-26.76s26.76,11.97,26.76,26.76v289.93c0,14.79-11.97,26.76-26.76,26.76Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M546.61,262.59c-6.89,0-13.79-2.63-19.06-7.9-10.53-10.5-10.53-27.58,0-38.12l85.2-85.28-85.2-85.29c-10.53-10.53-10.53-27.61,0-38.11,10.53-10.53,27.58-10.53,38.12,0l104.24,104.34c10.53,10.53,10.53,27.58,0,38.11l-104.24,104.34c-5.26,5.26-12.16,7.9-19.06,7.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.02,508.94c-1.68,0-3.42-.16-5.16-.5-14.61-2.82-24.16-16.95-21.32-31.59,41.78-215.84,230.3-372.51,448.25-372.51,14.9,0,26.95,12.06,26.95,26.95s-12.05,26.95-26.95,26.95c-192.18,0-358.43,138.3-395.34,328.87-2.47,12.87-13.77,21.82-26.43,21.82Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopoutIcon);
export default __webpack_public_path__ + "static/media/Popout_Icon.a30b139dfc873333ed5878876963c166.svg";
export { ForwardRef as ReactComponent };